import withStyles from "@material-ui/core/styles/withStyles"
import React from "react"
import { useSelector } from "react-redux"
import { fetchDevice } from "../../actions/deviceActions"
import { fetchUserFeatures } from "../../actions/featureActions"
import { fetchGroups } from "../../actions/groupActions"
import { fetchUserInsights } from "../../actions/userInsightsActions"
import { useLazyLoadSelector } from "../../util/redux"
import HomePageWrapper from "../Common/PageWrappers/HomePageWrapper"
import InsightsTable from "../UserInsights/insightstable"

const styles = () => ({})

const UserInsights = (props) => {
  useLazyLoadSelector((state) => state.userInsights.userInsightsData, fetchUserInsights, [], false)
  useLazyLoadSelector((state) => state.device.deviceData, fetchDevice, [], false)
  useLazyLoadSelector((state) => state.group.groupData, fetchGroups, [], false)
  useLazyLoadSelector((state) => state.feature.features, fetchUserFeatures, [], false)
  const loadingInsights = useSelector((state) => state.userInsights.userInsightInfoLoading || false)
  const loadingGroups = useSelector((state) => state.group.loadingGroups || false)

  const content = (
    <HomePageWrapper loading={loadingInsights || loadingGroups}>
      <div>
        <h1>Sentinel Insights</h1>
        <InsightsTable filters={props?.pageProps?.filters} setTab={props?.setTab} />
      </div>
    </HomePageWrapper>
  )
  return content
}

export default withStyles(styles)(UserInsights)
